import { Component, Input, OnInit } from '@angular/core';
import { NgModel, UntypedFormControl } from '@angular/forms';
import { IAbstractControl } from '@rxweb/types/reactive-form/i-abstract-control';

@Component({
  selector: 'pod-validation-messages',
  templateUrl: './validation-messages.component.html',
})
export class ValidationMessagesComponent {
  @Input() model: NgModel | UntypedFormControl | IAbstractControl<any, any>;
  @Input() fieldName?: string;
  @Input() submitted?: boolean;
  @Input() customMessage: { [key: string]: string };

  constructor() {}

  isSubmitted() {
    return (
      this.submitted ||
      (this.model instanceof NgModel && this.model.formDirective.submitted)
    );
  }
}
